// Ubicación en el repo: src/components/ComparisonAudiogramSVG.jsx
// Comparación de dos audiometrías — mismo layout que
// drawComparisonAudiogramSVG() del prototipo (línea ~1949): solo vía
// aérea (para que la lectura de la evolución sea más clara). El examen más
// antiguo se dibuja con los mismos colores pero atenuados (queda "atrás");
// el más reciente va con el color pleno (queda "adelante").
import { FREQS } from '../lib/exams';

const W = 560;
const H = 350;
const PAD_L = 58;
const PAD_R = 22;
const PAD_T = 18;
const PAD_B = 38;
const PLOT_W = W - PAD_L - PAD_R;
const PLOT_H = H - PAD_T - PAD_B;
const DB_LINES = [-10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120];
const MONO = "'JetBrains Mono', monospace";

function xFor(freq) {
  return PAD_L + (FREQS.indexOf(freq) / (FREQS.length - 1)) * PLOT_W;
}
function yFor(db) {
  return PAD_T + ((db + 10) / 130) * PLOT_H;
}

function Series({ data, color, symbol, faded }) {
  const pts = FREQS.filter((f) => data[f] !== undefined).map((f) => [xFor(f), yFor(data[f])]);
  if (pts.length === 0) return null;
  const opacity = faded ? 0.35 : 1;
  return (
    <g opacity={opacity}>
      <polyline points={pts.map((p) => p.join(',')).join(' ')} fill="none" stroke={color} strokeWidth={2} />
      {pts.map(([x, y], i) =>
        symbol === 'circle' ? (
          <circle key={i} cx={x} cy={y} r={6} fill={faded ? 'none' : color} stroke={color} strokeWidth={2} />
        ) : (
          <g key={i} stroke={color} strokeWidth={2}>
            <line x1={x - 5} y1={y - 5} x2={x + 5} y2={y + 5} />
            <line x1={x - 5} y1={y + 5} x2={x + 5} y2={y - 5} />
          </g>
        )
      )}
    </g>
  );
}

export default function ComparisonAudiogramSVG({ older, newer }) {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ maxWidth: 580 }}>
      {DB_LINES.map((db) => {
        const y = yFor(db);
        return (
          <g key={db}>
            <line x1={PAD_L} y1={y} x2={W - PAD_R} y2={y} stroke="#DCE3E5" strokeWidth={1} />
            {db % 20 === 0 && (
              <text x={PAD_L - 10} y={y + 4} fontSize={11} textAnchor="end" fill="#5B6B6E" fontFamily={MONO}>
                {db}
              </text>
            )}
          </g>
        );
      })}
      {FREQS.map((f) => {
        const x = xFor(f);
        return (
          <g key={f}>
            <line x1={x} y1={PAD_T} x2={x} y2={H - PAD_B} stroke="#DCE3E5" strokeWidth={1} />
            <text x={x} y={H - PAD_B + 17} fontSize={10.5} textAnchor="middle" fill="#5B6B6E" fontFamily={MONO}>
              {f >= 1000 ? `${f / 1000}k` : f}
            </text>
          </g>
        );
      })}
      <Series data={older.od || {}} color="#C4453C" symbol="circle" faded />
      <Series data={older.oi || {}} color="#2563A6" symbol="x" faded />
      <Series data={newer.od || {}} color="#C4453C" symbol="circle" />
      <Series data={newer.oi || {}} color="#2563A6" symbol="x" />
    </svg>
  );
}
